import { TextField } from '@mui/material';
import { useTenant } from '../contexts/TenantContext';
import { isDarkTheme } from '../utils/themeTraits';

// The funnel's text field: centred and narrower on wide screens, and light-on-dark on a dark theme.
const ThemedTextField = ({ sx, ...props }) => {
  const { displayConfig } = useTenant();
  const isDark = isDarkTheme(displayConfig);
  const glowColor = displayConfig?.primaryColor || "#108bdd";

  const baseTextFieldSx = {
    width: { xs: "100%", sm: "90%", md: "80%", lg: "70%", xl: "60%" },
    alignSelf: "center",
  };

  const darkTextFieldSx = {
    "& .MuiInputBase-input": {
      color: "#fff",
    },
    "& .MuiInputLabel-root": {
      color: "rgba(255, 255, 255, 0.6)",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: glowColor,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255, 255, 255, 0.2)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255, 255, 255, 0.4)",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: glowColor,
    },
    "& .MuiFormHelperText-root": {
      color: "rgba(255, 255, 255, 0.5)",
    },
  };

  return (
    <TextField
      sx={{ ...baseTextFieldSx, ...(isDark ? darkTextFieldSx : {}), ...sx }}
      {...props}
    />
  );
};

export default ThemedTextField;
